<template>
  <div class="search-results">
    <div class="container" @click="countAllResults">
      <div class="table-info">
        <div class="total">
          <div class="table-actions">
            <p>
              Showing <span>{{ this.countAllResults() }}</span> results
                of 500,000 searchable
                registrations
            </p>
            <a @click="clearFilters">Clear Filters</a>
          </div>
        </div>
        <div class="table-errors" v-if="currentUser.tier == 'FREE'">
          <p class="alert-custom">
            <span>{{ currentUser.remainingSearches }}</span> searches left! To
            continue using all features choose
            <router-link to="/pricing-plan">pricing plan</router-link>.
          </p>
        </div>
      </div>
      <table class="search-results-table">
        <thead>
          <tr>
            <!-- <td>
              <label class="custom-check">
                <input type="checkbox" name="selectAll" @change='selectAllInputs'/>
                <span class="checkmark"></span>
              </label>
            </td>
            <td> Country </td>
            <td> Manufacturer </td>
            <td> Product Name  </td>
            <td> Reg. No </td>
            <td> Class </td>
            <td> Product Category </td>
            <td> Expiration </td> -->
            <td></td>
            <td>Country</td>
            <td></td>
            <td></td>
            <td>Numbers of Licenses</td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <LoadAnimation v-if="this.$store.state.isLoading && this.isUser" />
        <!-- <tr v-on:click='openDetailBox(searchResult, $event)' v-for='searchResult of searchResults[1]' :key='searchResult._id'>
            <td class="checkbox-column"> 
              <label class="custom-check">
                <input type="checkbox"/>
                <span class="checkmark"></span>
              </label>
            </td>
            <td> {{ getCountryFromSource(searchResult.source) }} </td>
            <td> {{ searchResult.manufacturerName }} </td>
            <td> {{ searchResult.productName }} </td>
            <td> {{ searchResult.registrationNumber }} </td>
            <td> {{ searchResult.riskLevel }} </td>
            <td> {{ searchResult.productCategory }} </td>
            <td> 
              <span v-if='searchResult.expirationDate'>{{ searchResult.expirationDate }}</span> 
              <span v-else>Not Available</span>
            </td>
          </tr> -->
        <tbody
          v-for="(searchResultByCountry, index) in searchResults"
          :key="index"
        >
          <!-- <tr>
                <td></td>
                <td>{{getCountryFromSource(searchResultByCountry[0])}}</td>
                <td></td>
                <td></td>
                <td>Numbers of Licenses</td>
                <td></td>
                <td></td>
            </tr> -->
          <tr @click="displayAllInCountry">
            <td>
              <!-- <label class="custom-check">
                <input type="checkbox" name="selectAll" @change='selectAllInputs'/>
                <span class="checkmark"></span>
              </label> -->
            </td>
            <td class="flag-country-name">
              <img :src="getCountryFlag(searchResultByCountry[0])" />
              {{ getCountryFromSource(searchResultByCountry[0]) }}
            </td>
            <td></td>
            <td></td>
            <td colspan="2">
              {{ searchResultByCountry[1].length }} Total Licenses
            </td>
            <td>
              <button type="button" id="toggle-search-results-by-country">
                <svg
                  width="13"
                  height="12"
                  viewBox="0 0 13 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.5 12L0.00481418 0.749999L12.9952 0.75L6.5 12Z"
                    fill="#676868"
                  />
                </svg>
              </button>
            </td>
          </tr>

          <tr class="additional-info" style="display: none">
            <td colspan="8" class="additional-info-td">
              <table class="additional-info-table">
                <tr>
                  <td></td>
                  <td style="padding-left: 32px">Manufacturer</td>
                  <td>Product Name</td>
                  <td>Reg. No</td>
                  <td>Risk Level</td>
                  <td style="padding-left: 32px">Product Category</td>
                  <td>Expiration</td>
                </tr>
                <tr
                  v-for="searchResult in searchResultByCountry[1]"
                  :key="searchResult._id"
                  @click="removePrompt($event)"
                >
                  <td class="checkbox-column">
                    <label
                      class="custom-check"
                      v-on:click="openDetailBox(searchResult, $event)"
                    >
                      <input type="checkbox" />
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <!-- <td> {{ getCountryFromSource(searchResult.source) }} </td> -->
                  <td
                    @click="openRegDataModal(searchResult)"
                    v-if="searchResult.manufacturerName"
                  >
                    <span v-if="searchResult.tags && searchResult.tags.manufacturer != ''">
                      <p class="d-flex align-items-center search-col-d">
                        <img
                          src="@/assets/images/common/rose__meta_logo.png"
                          class="search-inline-img"
                          alt="Asia Actual Logo"
                        />{{ searchResult.tags.manufacturer }}
                      </p>
                    </span>
                    <span v-else class="d-flex align-items-center search-col-d"
                      ><p class="no-inline-img">
                        {{ searchResult.manufacturerName }}
                      </p></span
                    >
                  </td>
                  <td v-else style="text-align: center">-</td>

                  <td
                    @click="openRegDataModal(searchResult)"
                    v-if="searchResult.productName"
                  >
                    {{
                      searchResult.productName
                        .replace(/ ï¿½ï¿½ï¿½/g, "ï¿½ï¿½ï¿½")
                        .replace(/ï¿½ï¿½ï¿½/g, "&trade;")
                    }}
                  </td>
                  <td v-else style="text-align: center">-</td>

                  <td
                    @click="openRegDataModal(searchResult)"
                    v-if="searchResult.registrationNumber"
                  >
                    {{ searchResult.registrationNumber }}
                  </td>
                  <td v-else style="text-align: center">-</td>

                  <td
                    @click="openRegDataModal(searchResult)"
                    v-if="searchResult.rawRiskLevel"
                  >
                    {{ searchResult.rawRiskLevel }}
                  </td>
                  <td v-else style="text-align: center">-</td>

                  <td
                    @click="openRegDataModal(searchResult)"
                    v-if="searchResult.productCategory"
                  >
                    <span v-if="searchResult.tags && searchResult.tags.productCategory && searchResult.tags.productCategory.length > 0">
                      <p
                        v-for="(pTag, index) in searchResult.tags
                          .productCategory"
                        :key="index"
                        class="d-flex align-items-center search-col-d"
                      >
                        <img
                          src="@/assets/images/common/rose__meta_logo.png"
                          class="search-inline-img"
                          alt="Asia Actual Logo"
                        />{{ pTag }}
                      </p>
                    </span>
                    <span v-else class="d-flex align-items-center search-col-d"
                      ><p class="no-inline-img">
                        {{ searchResult.productCategory }}
                      </p></span
                    >
                  </td>
                  <td v-else style="text-align: center">-</td>
                  <td>
                    <span
                      @click="openRegDataModal(searchResult)"
                      v-if="searchResult.expirationDate"
                      >{{ getDate(searchResult.expirationDate) }}</span
                    >
                    <span v-else>Not Available</span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
        <tr class="locked-result" v-if="this.currentUser.tier == 'FREE'">
          <td colspan="8">
            <div class="locked-result-main">
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 10C16 8.897 15.103 8 14 8H13V5C13 2.243 10.757 0 8 0C5.243 0 3 2.243 3 5V8H2C0.897 8 0 8.897 0 10V18C0 19.103 0.897 20 2 20H14C15.103 20 16 19.103 16 18V10ZM5 5C5 3.346 6.346 2 8 2C9.654 2 11 3.346 11 5V8H5V5Z"
                  fill="#333333"
                />
              </svg>
              <p>To see all results choose</p>
              <router-link class="orange-btn" to="/billing-info">
                <a>Sign up for a free trial</a>
              </router-link>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <Search-result-detail
      @click="displaySaveModal"
      @setAlert="createExpiryAlert"
      @setTag="openSetTag"
      :searchData="searchRowItemData"
    />
    <SaveModal :searchRowItemData="searchRowItemData" @save="saveSearch" />
    <AvailableModal />
    <RegDataModal :regData="regData" :source="source" />
    <modals-container />
  </div>
</template>

<script>
// @ is an alias to /src
import SearchResultDetail from "@/components/global/search-result-detail.vue";
import SaveModal from "@/components/user/modals/saveFromTable.vue";
import AvailableModal from "@/components/user/modals/non-available.vue";
import RegDataModal from "@/components/user/modals/reg-data.vue";
import SearchTag from "@/components/global/searchTag";

import { axiosClient } from "@/axios-client";
import LoadAnimation from "@/components/global/loadAnimation.vue";
import * as isUserLoggedIn from "@/store/isUserLoggedIn";

// country flags
import singapore from "@/assets/images/components/flags/singapore.svg";
import malaysia from "@/assets/images/components/flags/malaysia.svg";
import thailand from "@/assets/images/components/flags/thailand.svg";
import hongKong from "@/assets/images/components/flags/hongKong.svg";
import china from "@/assets/images/components/flags/china.svg";
import usa from "@/assets/images/components/flags/usa.svg";
import philippines from "@/assets/images/components/flags/philippines.svg";
import indonesia from "@/assets/images/components/flags/indonesia.svg";
import australia from "@/assets/images/components/flags/australia.svg";
import vietnam from "@/assets/images/components/flags/vietnam.svg";

export default {
  name: "search-results",
  components: {
    SearchResultDetail,
    SaveModal,
    LoadAnimation,
    AvailableModal,
    RegDataModal,
  },

  props: ["searchResults", "totalResultsCount"],

  created() {
    axiosClient.get("v1/account").then((response) => {
      this.currentUser = response.data;
    });
  },

  data() {
    return {
      counter: 0,
      // search_results: [],
      searchRowItemData: {},
      currentUser: {},
      isUser: isUserLoggedIn.isUserLoggedIn(),
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      regData: {},
      source: null,
    };
  },

  methods: {
    async openRegDataModal(data) {
      this.source = data.source.replace(/ .*/, "");
      if (this.source == "Hong") this.source = "Hong Kong";
      if (this.source == "China's") this.source = "China";
      if (this.source == "VietNam") this.source = "Vietnam";
      this.$store.commit("resultsAreLoading");
      const responseData = await axiosClient.get("v1/search/registrations/metadata-view/"+ data._id).then((response) => response.data.data)
      this.regData = Object.keys(responseData).map((field) => {
        return {
          fieldName: field,
          message: responseData[field],
        };
      });
      var obj = {};
      for (let i = 0; i < this.regData.length; i++) {
        obj[this.regData[i].fieldName] = this.regData[i].message;
      }
      this.regData = obj;
      this.$store.commit("resultsLoaded");

      document.querySelector(".reg-modal-wrapper").style.opacity = "1";
      document.querySelector(".reg-modal-wrapper").style.zIndex = "999";
      document.querySelector(".reg-modal-wrapper").classList.add("isModalOpen");
      document.querySelector("body").style.overflow = "hidden";
    },
    openDetailBox(data, e) {
      if (
        e.target
          .closest(".checkbox-column")
          .classList.contains("checkbox-column")
      ) {
        let searchDetail = document.querySelector(".search-result-detail");
        //document.querySelector('.search-results .container').style.overflow = 'hidden';
        searchDetail.style.display = "block";
        searchDetail.style.left = e.pageX + "px";
        searchDetail.style.top = e.pageY + "px";
        this.searchRowItemData = data;
      }

      // if(e.target.closest('.checkbox-column').classList.contains('checkbox-column')) {
      //   searchDetail.style.display = 'none';
      //   document.querySelector('.search-results .container').style.overflow = 'scroll';
      // }
    },

    displayAllInCountry(e) {
      let tr = e.target.closest("tr");
      let additionalInfo = tr.nextSibling;

      tr.lastChild.firstChild.classList.toggle("active-btn");
      additionalInfo.style.display == "none"
        ? (additionalInfo.style.display = "table-row")
        : (additionalInfo.style.display = "none");
    },

    getCountryFromSource(source) {
      const sourceToCountry = {
        "Singapore HSA": "Singapore",
        "Philippines FDA": "Philippines",
        "Thailand FDA": "Thailand",
        USFDA: "United States",
        "Malaysia Medical Device Authority": "Malaysia",
        "Hong Kong MDD": "Hong Kong",
        "China's NMPA - Imported Products" : "China (Imported)",
        "Indonesia PRKT": "Indonesia",
        "Australia ARTG": "Australia",
        "VietNam Ministry of Health - Medical Disclosure Portal": "Vietnam"
      };
      return sourceToCountry[source];
    },

    getCountryFlag(source) {
      const sourceToFlag = {
        "Singapore HSA": singapore,
        "Thailand FDA": thailand,
        "Malaysia Medical Device Authority": malaysia,
        "Philippines FDA": philippines,
        USFDA: usa,
        "Hong Kong MDD": hongKong,
        "China's NMPA - Imported Products" : china,
        "Indonesia PRKT": indonesia,
        "Australia ARTG": australia,
        "VietNam Ministry of Health - Medical Disclosure Portal" : vietnam
      };
      return sourceToFlag[source];
    },

    displaySaveModal() {
      this.$emit("click", true);
    },

    displayLockedModal() {
      this.$emit("click", false);
    },

    removePrompt(e) {
      let inputs = document.querySelectorAll(
        ".search-results .checkbox-column input"
      );

      if (!e.target.closest(".checkbox-column")) {
        document.querySelector(".search-result-detail").style.display = "none";
        document.querySelector(".search-results .container").style.overflow =
          "scroll";

        inputs.forEach((el) => {
          el.checked = false;
        });
      }
    },

    selectAllInputs() {
      let inputs = document.querySelectorAll(
        "table.search-results-table input"
      );
      this.counter++;

      for (let input of inputs) {
        if (this.counter % 2 == 1) {
          input.checked = true;
        } else {
          input.checked = false;
        }
      }
    },

    saveSearch(inputValue, searchObject) {
      axiosClient
        .post("v1/search/registrations/saved-searches", {
          // keywordQuery: searchObject.keywordQuery,
          productName: searchObject.productName,
          productCategory: searchObject.productCategory,
          manufacturerName: searchObject.manufacturerName,
          specialty: searchObject.specialty,
          sources: searchObject.source,
          riskLevel: searchObject.riskLevel,
          resultsCount: "1",
          // _id: searchObject._id,
        })
        .then((response) => console.log(response))
        .catch((err) => console.log(err));
    },

    createExpiryAlert(data) {
      if (!data.expirationDate || data.expirationDate == "N/A") {
        document.querySelector(".available-modal-wrapper").style.opacity = "1";
        document.querySelector(".available-modal-wrapper").style.zIndex = "999";
        document
          .querySelector(".available-modal-wrapper")
          .classList.add("isModalOpen");
        document.querySelector("body").style.overflow = "hidden";
      } else {
        axiosClient.post("v1/alerts", {
          registrationId: data._id,
          numberOfMonthsPrior: 6,
          // productName: data.productName,
          // manufacturerName: data.manufacturerName,
          // expirationDate: data.expirationDate,
          // registrationNumber: data.registrationNumber,
          // source: data.source,
        });
      }
    },

    clearFilters() {
      this.$emit("clearFilters");
    },

    countAllResults() {
      let numOfResults = 0;
      let results = this.searchResults;
      results.forEach((el) => {
        numOfResults += el[1].length;
      });

      return numOfResults;
    },

    isUserPremium() {
      // return this.currentUser.tier == 'FREE' ? 0 : 1;
      if (this.currentUser.tier == "FREE") {
        return 0;
      } else {
        return 1;
      }
    },

    getDate(date) {
      if (date == "N/A") return date;
      let fullDate = new Date(date);
      let d = fullDate.getDate();
      let m = this.months[fullDate.getMonth()];
      let y = fullDate.getFullYear();
      return `${m} ${d}, ${y}`;
    },
    openSetTag(data) {
      this.openTaggingModal(data);
    },
    openTaggingModal(data) {
      const options = {};
      const style = { width: "60%", height: "auto" };
      const events = {
        opened: () => {
          console.log("Opened");
          this.$root.$emit("openedSearchTag", data);
        },
        closed: () => console.log("Closed"),
      };

      this.$modal.show(SearchTag, options, style, events);
    },
  },
};
</script>

<style lang="scss">
.my-inline-img {
  margin-right: 10px;
  margin-bottom: 6px;
}
.img-col-d {
  position: relative;
  left: -30px;
}
.search-results {
  margin-top: 35px;
  padding-bottom: 70px;

  .container {
    // max-height: 620px;
    max-height: 70vh;
    overflow: scroll;

    .table-info {
      background: none;
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;

      .table-actions {
        display: flex;
        align-items: center;

        p {
          margin: 0 35px 0 0;
          color: #676868;
        }

        a {
          display: block;
          color: #fcaf05;
          font-family: "Gotham-Medium";
          cursor: pointer;
        }
      }

      .table-errors {
        .alert-custom {
          color: #f26464;
          background: #fdefed;
          border: 1px solid #f26464;
          border-radius: 15px;
          padding: 2px 27px;
          margin: 0;

          a {
            color: #333;
            text-decoration: underline;
          }
        }
      }
    }

    .search-results-table {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0 5px;

      thead {
        tr td {
          font-family: "Gotham-Medium";
          padding: 11px 10px;

          &:first-of-type {
            padding-top: 0;
          }
        }
      }

      tbody {
        position: relative;
        tr {
          cursor: pointer;

          td {
            &.flag-country-name {
              img {
                margin-right: 20px;
              }
            }

            &:last-of-type {
              text-align: right;

              button {
                width: 35px;
                height: 35px;
                background: #ebebeb;
                border-radius: 5px;
                border: none;

                &:focus {
                  outline: none;
                }

                &.active-btn {
                  background: #fcaf05;

                  svg {
                    transform: rotate(180deg);

                    path {
                      fill: #fff;
                    }
                  }
                }
              }
            }
          }
        }
      }

      tr {
        background: #fff;

        &.additional-info {
          .additional-info-td {
            padding: 0;

            table {
              border-collapse: separate;
              border-spacing: 0 5px;
              background: #f9f9f9;
              width: 100%;
            }

            tr {
              &:first-of-type {
                td {
                  background: #f9f9f9;
                  padding: 4px 10px 10px 10px;
                  color: #676868;
                  position: sticky;
                  top: 0;
                  z-index: 99;
                  border-radius: 0;
                }
              }

              td {
                text-align: left;
              }
            }
          }
        }

        &.locked-result {
          position: relative;
          display: none;

          .locked-result-main {
            // position: absolute;
            // top: 0;
            // left: 0;
            // width: 100%;
            // height: 100%;
            // display: flex;
            // justify-content: space-between;
            // align-items: center;
            display: flex;
            justify-content: center;
            align-items: center;

            p {
              margin: 0 20px;
            }

            .orange-btn {
              width: 255px;
            }
          }
        }

        td {
          padding: 18px 10px;

          &:first-of-type {
            padding-left: 30px;
            padding-right: 30px;
            border-top-left-radius: 15px;
            border-bottom-left-radius: 15px;
          }

          &:nth-child(2) {
            width: 20%;
          }

          &:nth-child(4) {
            width: 11%;
          }

          // &:nth-child(5) {
          //   width: 11%;
          // }

          &:nth-child(6) {
            width: 15%;
          }

          // &:nth-child(7) {
          //   width: 15%;
          // }

          &:last-of-type {
            padding-right: 30px;
            border-top-right-radius: 15px;
            border-bottom-right-radius: 15px;
          }

          &:nth-child(3) {
            max-width: 300px;
          }
        }
      }
    }
  }
}
</style>
